<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1 appLocalizationPopupDirective localizationCode="OutstandingAbsenceReport">{{ 'OutstandingAbsenceReport' | translate: {Default: "Outstanding Absence Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-outstanding-absence-details-data-grid></app-outstanding-absence-details-data-grid>
    </div>
</app-layout>
